import React from 'react'
import RBI from './components/RBI'
import CommonBanner from '../../components/CommonBanner'
import SoftwareProviderCards from './components/SoftwareProviderCards'

function FacilationCenter() {
    function getCurrentFormattedDate() {
        const now = new Date();

        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0');
        const day = String(now.getDate()).padStart(2, '0');

        const hours = now.getHours();
        const minutes = now.getMinutes();

        if (hours > 9 || (hours === 9 && minutes >= 45)) {
            return `${year}-${month}-${day}`;
        } else {
            const yesterday = new Date(Date.now() - 86400000);
            const yes_year = yesterday.getFullYear();
            const yes_month = String(yesterday.getMonth() + 1).padStart(2, '0');
            const yes_day = String(yesterday.getDate()).padStart(2, '0');
            return `${yes_year}-${yes_month}-${yes_day}`;
        }
    }

    const formattedDate = getCurrentFormattedDate();

    return (
        <div>
            <CommonBanner isSquare={false} isOltas title='TIN Facilitation Centres' />
            <RBI />
            <p className='flex flex-col pt-6 w-full md:px-[68px]'>Updated as on {formattedDate} 10:00 AM</p>
            <SoftwareProviderCards />
        </div>
    )
}

export default FacilationCenter
